import { type QueryFunctionContext } from '@tanstack/react-query'
import { type AllShoppingCartsQueryKey } from '@/features/shop/services/Carts/queries'
import { apiPost } from '@/features/shared/utils/dataFetching'
import { formatAllCartsResponse } from '@/features/shop/services/Carts/utils'
import { type AllShoppingCartsResponse } from '@/features/shop/services/Carts/types'
import { cartQueryOptions } from '@/features/shop/services/Cart/queries'

export const fetchAllShoppingCarts = async (
  context: QueryFunctionContext<AllShoppingCartsQueryKey>,
) => {
  const { address, stores, userId } = context.queryKey[1]

  const allShoppingCarts = await apiPost<AllShoppingCartsResponse>({
    config: {
      url: 'cart/v2/all_shopping_cart.json',
      data: {
        stores,
        address,
      },
      params: { state: address.state, include_promos: true },
    },
    context,
    fetcherName: 'fetchAllShoppingCarts',
  })
  const carts = formatAllCartsResponse(allShoppingCarts)

  carts.forEach((cart) => {
    context.client.setQueryData(
      cartQueryOptions({
        storeParams: {
          user_id: userId,
          zip: address.zip ?? '',
          metro_id: cart.context.metro_id,
          store_id: cart.context.store_id,
          store_location_id: cart.context.store_location_id,
        },
        state: address.state ?? '',
      }).queryKey,
      // set the cart data only if it doesn't already exist
      (prevCart) => (prevCart ? undefined : cart.cart),
    )
  })
  return carts
}
